import { render } from "./Eforms.vue?vue&type=template&id=26118d7b&ts=true"
import script from "./Eforms.vue?vue&type=script&lang=ts"
export * from "./Eforms.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/project/shmu/shmu/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__